'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var util = require('../../helper/util');

var _ = require('underscore');

var textHelper = util.Text;
var styleHelper = require('../../helper/styleHelper');

var propConst = require('../../constants/propConst');
var appTypes = require('../../types/appTypes');

var OldTabBar = require('./HorizontalTabBar');
var VerticalScrollBar = require('../common/VerticalScrollBar');

var BarItem = React.createClass({
  render: function () {
    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
    var borderStr = '1px solid ' + this.props.borderColor || 'gray';
    var radiusStr = (this.props.radius || 0) + 'px';
    var style = JSON.parse(JSON.stringify(this.props.textStyle));
    style.border = borderStr;

    if(isTopBar) {
      style.borderTopLeftRadius = radiusStr;
      style.borderTopRightRadius = radiusStr;
    } else {
      style.borderBottomLeftRadius = radiusStr;
      style.borderBottomRightRadius = radiusStr;
    }
    if(this.props.isChecked) {
      var color = this.props.color || '#ffffff';
      if(isTopBar) {
        style.borderBottom = '1px solid ' + color;
      } else {
        style.borderTop = '1px solid ' + color;
      }

      style.backgroundColor = color;
      style.color = this.props.selectedTextColor || '#000000';
    } else {
      if(isTopBar) {
        style.borderBottom = borderStr;
      } else {
        style.borderTop = borderStr;
      }
      style.backgroundColor = this.props.tabColor || '#dddddd';
      style.color = this.props.textStyle.color || '#000000';
    }
    if(this.props.tabWidth) {
      style.width = this.props.tabWidth + 'px';
    }
    return (
      <div
        className="bar-item"
        style={style}
        onClick={this.handleClick}
      >
        <label className="bar-item-text">{ this.props.text }</label>
      </div>
    );
  },

  handleClick: function() {
    this.props.onItemClick(this.props.index);
  }

});

/***
 * 水平选项卡面板
 * @orthor allen
 * @createData 2018-6-25
 */
var HorizontalTabBarEx = React.createClass({
  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10) || 0
    }
  },

  render: function () {
    var txtStr;
    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
    var tabPosition = styleHelper.getPropertyValue(this.props,propConst.TAB_POSITION);

    var barHeight = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var barStyle = {
      height: barHeight
    };
    if(tabPosition === appTypes.HoriAlign.LEFT) {
      barStyle.marginLeft = (parseInt(this.props.tabEdge, 10) || 0 + 1) + 'px';
      barStyle.justifyContent = 'flex-start';
    } else if (tabPosition === appTypes.HoriAlign.CENTER){
      barStyle.justifyContent = 'center';
    } else if (tabPosition === appTypes.HoriAlign.RIGHT){
      barStyle.marginRight = (parseInt(this.props.tabEdge, 10) || 0) + 'px';
      barStyle.justifyContent = 'flex-end';
    }


    var textStyle = {
      lineHeight: barHeight + 'px'
    };
    styleHelper.StyleUtil(this.props, textStyle).text();

    if (this.props.text) {
      txtStr = textHelper.delimitText(styleHelper.getText(this.props),textHelper.DM_COMMA);
    }
    console.log(txtStr);
    var self = this;
    return (
      <div className="component-HorizontalTabBar">
        { !isTopBar &&
          this.renderContent()
        }
        <div
          className="bar-ex"
          style={barStyle}
        >
          {
            txtStr.map(function (itm, index) {
              return (<BarItem key={index}
                               {...this.props}
                               text={itm}
                               index={index}
                               isChecked={this.state.selectedIndex === index}
                               onItemClick={self.onItemClick}
                               textStyle={textStyle}
              />)
            }, this)
          }
        </div>
        {
          isTopBar && this.renderContent()
        }
      </div>
    )
  },

  renderContent: function() {
    var showScrollBar, scrollValue;
    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
    var barHeight = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var h = styleHelper.getHeight(this.props);
    var style = {
      backgroundColor: this.props.color || '#ffffff',
    };
    var borderStr = '1px solid ' + this.props.borderColor || 'gray';
    if(this.props.borderVisible) {
      style.border = borderStr;
    } else {
      style.borderTop = borderStr;
    }
    if(isTopBar) {
      style.marginTop = '-1px';
    } else {
      style.marginBottom = '-1px';
    }
    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      showScrollBar = this.props.verticalScrollbarShow;
      scrollValue = parseInt(this.props.verticalScrollbarProgress, 10) || 0;
    }
    return (
      <div className="content-ex" style={style}>
        {
          showScrollBar && (
            <VerticalScrollBar {...{value : scrollValue,right : -1,top : (isTopBar ? barHeight-1 : 0),height : h - barHeight - 2}}/>
          )
        }
      </div>
    );
  },

  componentDidMount: function() {
    $(ReactDOM.findDOMNode(this)).bind('tabClick',this._InteractiveClick);
  },

  _InteractiveClick: function(e, index) {
    this.onItemClick(index);
  },

  onItemClick: function (index) {
    this.setState({selectedIndex: index})
  },
});

var TabBarShell = React.createClass({


  render: function() {
    console.log(this.props);
    //目前仅对方角标签进行重写
    //斜角标签使用布局方式来绘制很麻烦，这里暂时只处理方角标签
    if(this.props.tabStyle === 'csSquare') {
      return (<HorizontalTabBarEx {...this.props}/>);
    } else {
      return (<OldTabBar {...this.props}/>);
    }
  },

  componentDidMount: function() {
    $(ReactDOM.findDOMNode(this)).bind('itemClick',this._InteractiveClick);
  },

  _InteractiveClick: function(e, index) {
    $(ReactDOM.findDOMNode(this).children[0]).trigger('tabClick', [index]);
  },

});

module.exports = TabBarShell;


// WEBPACK FOOTER //
// ./src/views/Components/HorizontalTabBarEx.jsx